<div class="main-content">
	<div class="container-fluid">
		<mat-card class="feature-surface">
			<mat-card-header>
				<mat-card-title>Vendor-Backed Payments</mat-card-title>
				<mat-card-subtitle>
					Commission + vendor relief across the cross-ledger receipts — pivot by brand, vendor, customer, or item
				</mat-card-subtitle>
			</mat-card-header>
			<mat-card-content>

				<form [formGroup]="filterForm" class="row mb-3">
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>From</mat-label>
							<input matInput type="date" formControlName="from">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>To</mat-label>
							<input matInput type="date" formControlName="to">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Vendor ID</mat-label>
							<input matInput formControlName="vendor_id">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Brand ID</mat-label>
							<input matInput formControlName="brand_id">
						</mat-form-field>
					</div>
					<div class="col-md-2">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Customer (debtor)</mat-label>
							<input matInput formControlName="debtorno">
						</mat-form-field>
					</div>
					<div class="col-md-2 d-flex align-items-center">
						<button mat-flat-button color="accent" (click)="load()" class="w-100">Apply</button>
					</div>
				</form>

				<mat-tab-group color="accent" mat-stretch-tabs="false" mat-align-tabs="start"
					(selectedIndexChange)="pivotTo(['brand','vendor','customer','item'][$event])">
					<mat-tab label="By Brand"></mat-tab>
					<mat-tab label="By Vendor"></mat-tab>
					<mat-tab label="By Customer"></mat-tab>
					<mat-tab label="By Item"></mat-tab>
				</mat-tab-group>

				<div *ngIf="loading" class="text-center my-4">
					<mat-progress-spinner diameter="32" mode="indeterminate" color="accent"></mat-progress-spinner>
				</div>

				<table class="feature-table mt-2" *ngIf="!loading">
					<thead>
						<tr>
							<th>{{ pivot | titlecase }}</th>
							<th class="is-num">Units</th>
							<th class="is-num">Gross AR</th>
							<th class="is-num">Vendor relief</th>
							<th class="is-num">Commission</th>
							<th class="is-num">Comm / unit</th>
							<th class="is-num">Invoices</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let r of rows">
							<td>{{ r.label }}</td>
							<td class="is-num">{{ r.units | number:'1.0-2' }}</td>
							<td class="is-num">{{ r.gross_ar | currency }}</td>
							<td class="is-num">{{ r.vendor_relief | currency }}</td>
							<td class="is-num">{{ r.commission | currency }}</td>
							<td class="is-num">{{ r.commission_per_unit | currency }}</td>
							<td class="is-num">{{ r.invoices }}</td>
						</tr>
						<tr *ngIf="!rows.length">
							<td colspan="7" class="text-center text-muted">no rows for this filter</td>
						</tr>
						<tr *ngIf="totals && rows.length" class="is-total">
							<td>Total</td>
							<td class="is-num">{{ totals.units | number:'1.0-2' }}</td>
							<td class="is-num">{{ totals.gross_ar | currency }}</td>
							<td class="is-num">{{ totals.vendor_relief | currency }}</td>
							<td class="is-num">{{ totals.commission | currency }}</td>
							<td class="is-num"></td>
							<td class="is-num">{{ totals.invoices }}</td>
						</tr>
					</tbody>
				</table>

				<div class="text-right mt-3">
					<button mat-stroked-button color="accent" (click)="exportCsv()" [disabled]="!rows.length">
						<i class="material-icons" style="vertical-align: -4px;">file_download</i> Export CSV
					</button>
				</div>

			</mat-card-content>
		</mat-card>
	</div>
</div>
